module.exports = __webpack_public_path__ + "static/media/comment-slash.7ec02369.svg";